import React, { useState } from 'react';
import LookupForm from '../components/LookupForm';
import ResultDisplay from '../components/ResultDisplay';
import NavigationBar from '../components/NavigationBar';
import { lookupPhone } from '../services/api';

function LookupPage({ token, onLogout }) {
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLookup = async (phone) => {
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const data = await lookupPhone(phone, token);
      setResult(data);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setError('No carrier information found for this phone number');
      } else if (err.response && err.response.status === 401) {
        setError('Session expired. Please log in again.');
        setTimeout(() => onLogout(), 2000);
      } else if (err.response && err.response.status === 403) {
        if (err.response.data?.needsApproval) {
          setError('Account not approved for phone lookups. Please contact an administrator.');
          setTimeout(() => onLogout(), 3000);
        } else {
          setError('Access denied. Please contact an administrator.');
        }
      } else {
        setError('Lookup failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '20px'
  };

  return (
    <div style={containerStyle}>
      <NavigationBar 
        token={token} 
        onLogout={onLogout}
        title="TeleHelp v4"
        subtitle="Law Enforcement Phone Carrier Lookup"
      />
      
      <LookupForm onLookup={handleLookup} loading={loading} />
      
      <ResultDisplay result={result} error={error} />
    </div>
  );
}

export default LookupPage; 